import './expandButton.tpl.html';

angular.module('shared.expandButton', []).directive('sbsfExpandButton', directive);

/**
 * Expand button directive
 *
 * @return {object}
 */
function directive() {
  return {
    templateUrl: 'shared/expandButton/expandButton.tpl.html',
    restrict: 'E',
    scope: {
      expanded: '='
    }
  };
}
